import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { company } from '../../data/company';
import { QuoteForm } from '../shared/QuoteForm';
export function QuoteSection() {
  return <section id="quote" className="bg-ink py-20 md:py-32" aria-labelledby="quote-heading" data-id="element-58" data-mp="20pdjiduhkinb">
      <div className="mx-auto grid max-w-[1320px] gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-59" data-mp="24q5rl3rmghi0">
        <div className="text-center lg:col-span-5 lg:text-left" data-id="element-60" data-mp="2sg9n0nunpaxx">
          <h2 id="quote-heading" className="font-display text-5xl font-bold uppercase leading-[0.9] text-chalk md:text-7xl" data-id="element-61" data-mp="2sdx52aowf0kv">
            Request a <span className="text-flame" data-id="element-62" data-mp="2jejv7gwv49zm">Quote</span>
          </h2>
          <p className="mx-auto mt-6 max-w-md text-lg leading-relaxed text-muted lg:mx-0" data-id="element-63" data-mp="2odwr0r5porec">
            Share your requirements or attach a spec sheet. Our team will review it and reply with product details
            and pricing.
          </p>
          <ul className="mx-auto mt-10 max-w-md space-y-3 lg:mx-0" data-id="element-64" data-mp="1d0u83pg53pr0">
            <li data-id="element-65" data-mp="2tt5qklffbnbf">
              <a href={company.phoneHref} className="flex items-center justify-center gap-4 rounded-2xl border border-edge bg-coal p-4 transition-colors duration-150 hover:border-flame lg:justify-start" data-id="element-66" data-mp="2tuql4b1qn69a">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-flame text-ink" data-id="element-67" data-mp="33q1yaoxi05ex">
                  <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="3cstd8ypl1jbb" />
                </span>
                <span className="text-lg font-semibold text-chalk" data-id="element-69" data-mp="3cqgl5sq41skj">{company.phone}</span>
              </a>
            </li>
            <li data-id="element-70" data-mp="3micw44dapd66">
              <a href={company.emailHref} className="flex items-center justify-center gap-4 rounded-2xl border border-edge bg-coal p-4 transition-colors duration-150 hover:border-flame lg:justify-start" data-id="element-71" data-mp="3miw5gwovqt8l">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-flame text-ink" data-id="element-72" data-mp="3vk42lbfnto13">
                  <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="3rjk3w3ffuccu" />
                </span>
                <span className="min-w-0 break-all text-left text-base font-semibold text-chalk sm:text-lg" data-id="element-74" data-mp="2h2sjuo1bqjd">
                  {company.email}
                </span>
              </a>
            </li>
          </ul>
        </div>
        <div className="rounded-[28px] border border-edge bg-coal p-5 sm:p-10 lg:col-span-7" data-id="element-75" data-mp="cburp2x9mlg9">
          <QuoteForm data-id="element-76" data-mp="h68sxlylzmsu" />
        </div>
      </div>
    </section>;
}